import { createSelector } from 'reselect';

const layout = (state: any) => state.get('layout');
const layoutSelector = createSelector([layout], (layoutData: any) => layoutData.toJS());

export {
	layoutSelector,
};
